import React, { useRef, useEffect } from "react";
import classes from "./Sports.module.css";
import Container from "../../UI/Container/Container";
import image from "../../../assets/images/studentlife-sports--resized.jpg";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Sports = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const imageRef = useRef(0);
  const overlayRef = useRef(0);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: imageRef.current,
        start: "top 50%",
      },
    });

    timeline.to(imageRef.current, {
      opacity: 1,
      duration: 0.5,
      ease: "sine.out",
    });
    timeline.to(overlayRef.current, {
      opacity: 1,
      duration: 0.5,
      ease: "sine.out",
    });
  });

  return (
    <div className={classes.Sports}>
      <img ref={imageRef} src={image} alt="Dickinson football team" />
      <div ref={overlayRef} className={classes.Overlay}>
        <Container>
          <div className={classes.Content}>
            <h2>Dickinson doesn’t leave anything on the field.</h2>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Sports;
